const API_URL =
	process.env.NODE_ENV === "development"
		? "http://localhost:3000/api/generate-question"
		: "https://get2know-five.vercel.app/api/generate-question";

export async function generateQuestion(userData) {
	console.log(userData.subject);
	if (!userData) return "No user data provided";

	try {
		// Include language in the body
		const body = {
			...userData,
		};

		const response = await fetch(API_URL, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(body),
		});

		if (!response.ok) return "Could not generate question.";

		const data = await response.json();
		return data.question || "Could not generate question.";
	} catch (error) {
		console.error(error);
		return "Could not generate question.";
	}
}
